import { Button, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Link, useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import CustomProductActionBottom from "../CustomProductActionBottom";
export default function Description({ onSave, defaultValues, ...props }: any) {
  let selectLanguage = props?.selectLanguage || "english";

  const [activeTab, setActiveTab] = React.useState(0);
  const record = useRecordContext();
  const basicData = record?.data?.basic;
  const data = record?.data?.basic?.description;
  // console.log("Description record:", data);
  const {
    control,
    getValues,
    formState: { errors, isDirty },
    reset,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {
      productname_ps: "",
      description_ps: "",
    },
  });
  React.useEffect(() => {
    if (data) {
      reset({
        productname_en: data?.en?.title || "",
        description_en: data?.en?.description || "",
        productname_es: data?.es?.title || "",
        description_es: data?.es?.description || "",
        productname_ps: data?.ps?.title || "",
        description_ps: data?.ps?.description || "",
      });
    }
  }, [data, reset]);
  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = "description_ps";
    console.log("Description data to save:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  const handleReset = () => {
    reset();
  };

  //当isDirty 发生变化时，传递给上层 props.onDirtyChange(isDirty)
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  return (
    <SectionStyled id={props.id ? props.id : "section_productinfo"}>
      <SectionTitle title="Description - Provide a brief description of this product" />
      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {/* Pashto Tab */}
        <Box
          sx={{
            display: selectLanguage == "linkto_pashto" ? "block" : "none",
            pt: 2,
            pb: 2,
          }}
        >
          <Controller
            name="productname_ps"
            control={control}
            render={({ field }) => (
              <CustomProductTextField
                {...field}
                label="Pashto Product Name"
                fullWidth
                variant="outlined"
                placeholder="Enter the name of the product"
              />
            )}
          />
          <Controller
            name="description_ps"
            control={control}
            render={({ field }) => (
              <CustomProductTextField
                {...field}
                label="Pashto Description"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                placeholder="Enter the description of the product"
                sx={{ marginTop: "5px" }}
              />
            )}
          />
        </Box>
        {/* Form Actions */}
      </Box>
      <CustomProductActionBottom>
        {/* <Button variant="outlined" onClick={handleReset} disabled={!isDirty}>
            Reset
          </Button> */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
